
import { defineComponent, computed } from 'vue';
import value0 from './assets/value-0.svg?raw';
import value1 from './assets/value-1.svg?raw';
import value2 from './assets/value-2.svg?raw';
import value3 from './assets/value-3.svg?raw';
import { store as globalsStore } from 'plugins/store/globals';

export default defineComponent({
  name: "LifestyleBlock",
  setup() {

    const icons = [value0, value1, value2, value3];

    function getIcon(index: number) {
      return icons[index];
    }

    return {
      values: computed(() => globalsStore?.values),
      getIcon
    }
  }
});
